import React from 'react';
import { DisabledMarkerProps } from './types';
import { MarkerF } from '@react-google-maps/api';

const DisabledMarker: React.FC<DisabledMarkerProps> = (props) => {
    
  const icon = {
    scale: 5,
    fillOpacity: 1,
    strokeWeight: 4,
    strokeColor: 'transparent',
    fillColor: 'transparent',
    path: google.maps.SymbolPath.CIRCLE,
  };

  return <MarkerF icon={icon} options={{ zIndex: 100 }} {...props} />;
};

export default DisabledMarker;